<div *ngIf="upstream_screen">
<h3>{{'upstream' | titleText }}</h3>
 
<div  class="card">
    <div>
        <input type="text" placeholder="Enter FJL ID for new SPL installation" id="fjl_Id" name="fjlId" required (change)="inputOnChange($event)"/>
        <select (change)="onfjlSPLChange($event)">
        <option value="">Select FJL Splitter type :</option><option value="1:4">SPLITTER_1:4</option><option value="1:8">SPLITTER_1:8</option></select>
        <button (click)="fjladdSPL()">Add New FJL-SPL</button>
    </div> 
    
    <app-table 
        [inputData]="inputData"
        (appItemEvent)="receiveTableEventUpstream($event)" >
    </app-table>
</div>

</div>

<div *ngIf="select_smp_screen">
    <app-select-smp-n2p
        [inputData]="inputData"
    ></app-select-smp-n2p>
</div>

<!-- spinner Component Called-->
<div *ngIf="isLoading">
  <ngx-spinner type = "ball-scale-multiple"></ngx-spinner> 
</div>